import { Injectable } from '@angular/core';
import { GetAllResponse, SingleResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { Observable } from 'rxjs';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { QualitySuites } from '../model/qualitySuites.model';
import { TicketRequest } from '../model/ticket-access-request.model';

@Injectable({
  providedIn: 'root'
})

export class QualitySuitesService {

  constructor(private utilities: UtilitiesService) { }

  requestQualitySuitesAccess(body): Observable<GetAllResponse<QualitySuites>> {
    const url = environment.portalURL + API_URL.QUALITY_SUITES_REQUEST_URL;
    return this.utilities.req.httpPost<GetAllResponse<QualitySuites>>(url, body);
  }

  getRequestQualitySuitesAccess(id): Observable<GetAllResponse<QualitySuites>> {
    const url = environment.portalURL + API_URL.QUALITY_SUITES_REQUEST_URL + `${id}`;
    return this.utilities.req.httpGet<GetAllResponse<QualitySuites>>(url);
  }

  getRequestQualitySuitesAccessList(): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.QUALITY_SUITES_REQUEST_URL;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

  getSSOList(body): Observable<GetAllResponse<TicketRequest>> {
    const url = environment.portalURL + API_URL.SSO_URL + `?firstName=${body.firstName}&lastName=${body.lastName}&email=${body.email}`;
    return this.utilities.req.httpGet<GetAllResponse<TicketRequest>>(url);
  }

  createSupportCentralForm(body): Observable<GetAllResponse<QualitySuites>> {
    const url = API_URL.SUPPORT_CENTRAL_SDR_CREATE;
    return this.utilities.req.httpPost<SingleResponse<any>>(url, body);
  }

  syncSupportCentralForm(): Observable<GetAllResponse<QualitySuites>> {
    const url = API_URL.SUPPORT_CENTRAL_SDR_SYNC;
    return this.utilities.req.httpGet<SingleResponse<any>>(url);
  }
}
